import { ARTIST_BIO } from "../lib/exhibitionData";

export default function ArtistBio() {
  return (
    <section
      id="artist"
      data-testid="artist-bio-section"
      className="relative bg-[#0A0A0A] text-[#F5F0E8] overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Artist portrait */}
          <div className="lg:col-span-5 relative">
            <div className="absolute -top-4 -left-4 w-full h-full border border-[#C41E1E] hidden md:block pointer-events-none" />
            <div className="relative aspect-[4/5] overflow-hidden bg-[#0A0A0A]">
              <img
                src="/artist/ndoye.jpg"
                alt="Portrait of Abdou Karim Ndoye"
                className="w-full h-full object-cover pl-no-bw pl-soft-in"
              />
            </div>
            <div className="mt-6 flex items-center gap-3">
              <span className="w-8 h-[1px] bg-[#C41E1E]" />
              <span className="text-[10px] uppercase tracking-[0.3em] text-[#F5F0E8]/70">
                Photographer · Dakar, Senegal
              </span>
            </div>

            {/* Inset: with President Bassirou Diomaye Faye */}
            <figure className="mt-8 border border-[#F5F0E8]/15 p-3">
              <div className="aspect-[4/3] overflow-hidden bg-[#111]">
                <img
                  src="https://customer-assets.emergentagent.com/job_premiere-ligne/artifacts/jyvxbbkp_Abdou%20Karim%20Ndoye%20and%20President%20Bassirou%20Diomaye%20Faye.jpg"
                  alt="Abdou Karim Ndoye with President Bassirou Diomaye Faye at the Palais présidentiel, Dakar"
                  className="w-full h-full object-cover pl-no-bw"
                />
              </div>
              <figcaption className="mt-3 flex items-start gap-3 text-[10px] uppercase tracking-[0.25em] text-[#F5F0E8]/65">
                <span className="text-[#C41E1E] font-semibold">Dakar, 2024</span>
                <span className="w-4 h-[1px] bg-[#F5F0E8]/30 mt-[6px]" />
                <span>
                  The artist with President Bassirou Diomaye Faye at the Palais
                  présidentiel.
                </span>
              </figcaption>
            </figure>
          </div>

          {/* Copy */}
          <div className="lg:col-span-7">
            <span className="overline text-[#C41E1E]">The Artist</span>
            <h2 className="mt-4 font-serif-display text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
              {ARTIST_BIO.name}
            </h2>

            <blockquote className="mt-10 md:mt-14 border-l-2 border-[#C41E1E] pl-6 md:pl-8">
              <p className="font-serif-display italic text-2xl md:text-4xl lg:text-5xl leading-[1.15] text-[#F5F0E8]">
                "{ARTIST_BIO.quote}"
              </p>
              <footer className="mt-5 text-[11px] uppercase tracking-[0.3em] text-[#F5F0E8]/65">
                {ARTIST_BIO.quoteAttribution}
              </footer>
            </blockquote>

            <div className="mt-10 md:mt-14 space-y-5 text-base md:text-lg leading-relaxed text-[#F5F0E8]/80 max-w-2xl">
              {ARTIST_BIO.long.split("\n\n").map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
